import React from "react";
import { MDBContainer } from "mdb-react-ui-kit";
import { connect } from "react-redux";
import TextInput from "../components/textInput/TestInput";

const Test = ({}) => {
  return (
    <MDBContainer id="containertest" className="mt-5">
      <TextInput
        tabSelected="emissions"
        selectTab={(e) => console.log("selectTab", e)}
        flavor="main"
        maxChars={5000}
        newEmission={(e) => console.log("newEmission", e)}
        label="Enter Text"
      />
    </MDBContainer>
  );
};

const mapStateToProps = (state) => ({
  ...state,
});

export default connect(mapStateToProps, {})(Test);
